/* import jQuery from "jquery";
window.$ = window.jQuery = jQuery; */
import Swiper from 'swiper';
import SwiperCore, { Navigation, Pagination} from "swiper";

const swiper = new Swiper(".heroswiper", {
	modules: [Navigation, Pagination],
	loop: true,
	grabCursor: true,
	pagination: {
		el: '.swiper-pagination',
		clickable:true,
	},	
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
	on: {
		init: function (s) {
			/* console.log('swiper initialized'); */
			const prevSlide = (s.realIndex == 0 ? s.slides.length : s.realIndex);
			const nextSLide = (s.realIndex == s.slides.length-1 ? 1 : s.realIndex + 2);
			document.querySelector('.swiper-button-prev').textContent = prevSlide;
			document.querySelector('.swiper-button-next').textContent = nextSLide;
		},
		slideChange: function (s) {
			const prevSlide = (s.realIndex == 0 ? s.slides.length : s.realIndex);
			const nextSLide = (s.realIndex == s.slides.length-1 ? 1 : s.realIndex + 2);
			document.querySelector('.swiper-button-prev').textContent = prevSlide;
			document.querySelector('.swiper-button-next').textContent = nextSLide;
			/* console.log('Links:' + (s.realIndex == 0 ? s.slides.length : s.realIndex));
			console.log('Rechts:'+  (s.realIndex == s.slides.length-1 ? 1 : s.realIndex + 2)); */
		},
	},
});

		









